import NoAuthContent from './NoAuthContent';
import OrderItem from './OrderItem';
import OrdersContent from './OrdersContent';
import Orders from './Orders';

export default { NoAuthContent, OrderItem, OrdersContent, Orders };
